const appName = 'BrackLaw';

export default appName;
